import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../theme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  ul: {
    marginTop: 0,
    paddingLeft: theme.spacing(2.5),
  },
}));
